var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header py-4",class:( _obj = {}, _obj[("bg-" + (_vm.$props.variant))] = _vm.$props.variant, _obj )},[_c('b-container',[_c('div',{staticClass:"header-body py-1 d-flex align-items-center"},[(!!_vm.$slots.title)?_c('h2',{staticClass:"header-title mr-3 mb-0"},[_vm._t("title")],2):_vm._e(),_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }